import React from 'react';
import { Container, Box, Typography, Paper, Grid, Divider, Link } from '@mui/material';
import { Email, Phone, HelpOutline } from '@mui/icons-material';

const SupportPage = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Need Help? Contact Support
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          We're here to assist you. Reach out to us via email or phone.
        </Typography>
      </Box>

      <Paper sx={{ p: 4, mt: 4, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="h5" gutterBottom>
          Contact Information
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Email sx={{ mr: 2, color: 'primary.main' }} />
              <Typography variant="body1">
                <strong>Email:</strong>{' '}
                <Link href="mailto:support@inkedupmanager.com" underline="hover">
                  support@inkedupmanager.com
                </Link>
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Phone sx={{ mr: 2, color: 'primary.main' }} />
              <Typography variant="body1">
                <strong>Phone:</strong> 
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Support Hours:</strong>
            </Typography>
            <Typography variant="body2">Monday - Friday: 9:00 AM - 6:00 PM (EST)</Typography>
            <Typography variant="body2">Saturday - Sunday: Closed</Typography>
          </Grid>
        </Grid>
      </Paper>

      <Divider sx={{ my: 4 }} />

      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h6" color="textSecondary">
          Have questions? Check our <Link href="/faq" underline="hover">FAQ section</Link> for quick answers.
        </Typography>
      </Box>
    </Container>
  );
};

export default SupportPage;
